import React from "react";

function CoachGradeSkeleton() {
  return (
    <div className="overflow-hidden rounded-[2rem] border border-slate-200 bg-white shadow-xl shadow-slate-200/60 dark:border-white/10 dark:bg-slate-900 dark:shadow-black/20">
      <div className="space-y-4 p-4">
        <div className="h-8 w-56 animate-pulse rounded-full bg-slate-200 dark:bg-white/10" />

        {Array.from({ length: 8 }).map((_, index) => (
          <div
            key={index}
            className="h-16 animate-pulse rounded-2xl bg-slate-100 dark:bg-white/10"
          />
        ))}
      </div>
    </div>
  );
}

export default CoachGradeSkeleton;